// @ts-nocheck
import React, { useState, useRef, useEffect, useContext } from "react";
import { SHOW_PER_PAGE_SIGNATURES } from './config/featureFlags';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import { DataContext } from './App';
import { isPastCheckoutGrace } from './utils/charterWindow';
import { syncCheckinPreview, computeCheckinPreview, isCheckinPreview } from './utils/previewMode';
import authService from './authService';
import { savePage3DataHybrid, getPage3DataHybrid, getPage1DataHybrid, getPage4DataHybrid, getYachtItems, getMasterItems, getPage5Agreement } from './services/apiService';
import { savePageMedia, getPageMedia, mergeMediaIntoItems } from './utils/mediaStorage';

// 🔥 IMPORT ΑΠΟ SharedComponents (ΤΑ ΚΟΙΝΑ)
import {
  brand,
  // EMPLOYEE_CODES, // removed - using authService
  I18N,
  uid,
  mid,
  compressSignature,
  compressImageWithLogging,
  BookingInfoBox,
  PageHeader,
  TopControls,
  ModeDisplay,
  formatDate,
  ActionButtons,
  SignatureBox,
  TableSection,
  SHOW_BOOKING_INFO_ON_CHECKLIST_PAGES
} from './shared-components';
import DynamicBox from './components/DynamicBox';

// Section key lists are loaded dynamically from master_items (page_group='page3'). See loader useEffect.

const VESSEL_NAME_TO_ID: Record<string, number> = {
  'bob': 8, 'perla': 7, 'infinity': 6, 'maria 1': 1,
  'maria 2': 2, 'bar bar': 4, 'kalispera': 5, 'valesia': 3
};

export const ITEM_LABELS = {
  engine: { en: "engine", el: "κινητήρας", it: "motore", de: "Motor", ru: "двигатель", fr: "moteur", ro: "motor", pl: "silnik", he: "מנוע", es: "motor" },
  anchor_windlass: { en: "anchor windlass", el: "εργάτης άγκυρας", it: "verricello ancora", de: "Ankerwinde", ru: "якорная лебёдка", fr: "guindeau", ro: "vinciul de ancoră", pl: "wciągarka kotwiczna", he: "כננת עוגן", es: "molinete de ancla" },
  mainsail: { en: "mainsail", el: "κύριο πανί", it: "randa", de: "Großsegel", ru: "грот", fr: "grand-voile", ro: "vela principală", pl: "grot", he: "מפרש ראשי", es: "vela mayor" },
  genoa: { en: "genoa", el: "τζένοα", it: "genoa", de: "Genua", ru: "генуя", fr: "génois", ro: "genoa", pl: "genua", he: "ג'נואה", es: "génova" },
  autopilot: { en: "autopilot", el: "αυτόματος πιλότος", it: "pilota automatico", de: "Autopilot", ru: "автопилот", fr: "pilote automatique", ro: "pilot automat", pl: "autopilot", he: "טייס אוטומטי", es: "piloto automático" },
  gps_plotter: { en: "gps/gps plotter", el: "GPS / plotter", it: "GPS / plotter", de: "GPS / Plotter", ru: "GPS / плоттер", fr: "GPS / traceur", ro: "GPS / plotter", pl: "GPS / ploter", he: "GPS / פלוטר", es: "GPS / plotter" },
  electricity: { en: "electricity", el: "ηλεκτρικά", it: "elettricità", de: "Elektrik", ru: "электричество", fr: "électricité", ro: "electricitate", pl: "elektryczność", he: "חשמל", es: "electricidad" },
  fridge: { en: "fridge", el: "ψυγείο", it: "frigorifero", de: "Kühlschrank", ru: "холодильник", fr: "réfrigérateur", ro: "frigider", pl: "lodówka", he: "מקרר", es: "nevera" },
  gas_oven: { en: "gas oven", el: "φούρνος γκαζιού", it: "forno a gas", de: "Gasofen", ru: "газовая плита", fr: "four à gaz", ro: "cuptor pe gaz", pl: "kuchenka gazowa", he: "תנור גז", es: "horno de gas" },
  electric_toilet_pump: { en: "electric toilet pump", el: "αντλία τουαλέτας", it: "pompa WC elettrica", de: "elektr. Toilettenpumpe", ru: "электр. насос унитаза", fr: "pompe WC électrique", ro: "pompă electrică de toaletă", pl: "pompa toalety elektr.", he: "משאבת שירותים חשמלית", es: "bomba WC eléctrica" },
  fresh_water_pump: { en: "fresh water pump", el: "αντλία γλυκού νερού", it: "pompa acqua dolce", de: "Frischwasserpumpe", ru: "насос пресной воды", fr: "pompe eau douce", ro: "pompă de apă dulce", pl: "pompa wody słodkiej", he: "משאבת מים מתוקים", es: "bomba de agua dulce" },
  bilge_pump: { en: "bilge pump", el: "αντλία σεντινών", it: "pompa di sentina", de: "Bilgenpumpe", ru: "трюмная помпа", fr: "pompe de cale", ro: "pompă de santină", pl: "pompa zęzowa", he: "משאבת תחתית", es: "bomba de achique" },
  radio_mp3: { en: "radio/mp3 player", el: "ραδιόφωνο / mp3", it: "radio / mp3", de: "Radio / MP3", ru: "радио / mp3", fr: "radio / mp3", ro: "radio / mp3", pl: "radio / mp3", he: "רדיו / mp3", es: "radio / mp3" },
  cleanliness: { en: "cleanliness", el: "καθαριότητα", it: "pulizia", de: "Sauberkeit", ru: "чистота", fr: "propreté", ro: "curățenie", pl: "czystość", he: "ניקיון", es: "limpieza" },
  fuel_water: { en: "fuel-water", el: "καύσιμα / νερό", it: "carburante / acqua", de: "Kraftstoff / Wasser", ru: "топливо / вода", fr: "carburant / eau", ro: "combustibil / apă", pl: "paliwo / woda", he: "דלק / מים", es: "combustible / agua" },
  fuel_filling: { en: "fuel-filling", el: "ανεφοδιασμός καυσίμων", it: "rifornimento", de: "Betankung", ru: "заправка топливом", fr: "ravitaillement", ro: "alimentare cu combustibil", pl: "tankowanie", he: "תדלוק", es: "repostaje" },
  bimini_sprayhood: { en: "bimini sprayhood", el: "bimini / sprayhood", it: "bimini / sprayhood", de: "Bimini / Sprayhood", ru: "бимини / спрейхуд", fr: "bimini / capote", ro: "bimini / sprayhood", pl: "bimini / sprayhood", he: "בימיני / ספרייהוד", es: "bimini / sprayhood" },
  bow_thruster: { en: "bow thruster", el: "προωστήρας πλώρης", it: "elica di prua", de: "Bugstrahlruder", ru: "носовое подруливающее", fr: "propulseur d'étrave", ro: "propulsor de prova", pl: "ster strumieniowy", he: "דחפן חרטום", es: "hélice de proa" },
  generator: { en: "generator", el: "γεννήτρια", it: "generatore", de: "Generator", ru: "генератор", fr: "générateur", ro: "generator", pl: "generator", he: "גנרטור", es: "generador" },
  electric_winch: { en: "electric winch", el: "ηλεκτρικό βίντζι", it: "winch elettrico", de: "elektrische Winsch", ru: "электр. лебёдка", fr: "winch électrique", ro: "vinci electric", pl: "wciągarka elektryczna", he: "כננת חשמלית", es: "winche eléctrico" },
  winch: { en: "winch", el: "βίντζι", it: "winch", de: "Winsch", ru: "лебёдка", fr: "winch", ro: "vinci", pl: "wciągarka", he: "כננת", es: "winche" },
  hydraulic_gangway: { en: "hydraulic gangway", el: "υδραυλική πασαρέλα", it: "passerella idraulica", de: "hydraulische Gangway", ru: "гидравлический трап", fr: "passerelle hydraulique", ro: "pasarelă hidraulică", pl: "trap hydrauliczny", he: "גשר הידראולי", es: "pasarela hidráulica" },
  ac: { en: "a/c", el: "κλιματισμός", it: "aria condizionata", de: "Klimaanlage", ru: "кондиционер", fr: "climatisation", ro: "aer condiționat", pl: "klimatyzacja", he: "מיזוג אוויר", es: "aire acondicionado" },
  water_maker: { en: "water maker", el: "αφαλάτωση", it: "dissalatore", de: "Wassermacher", ru: "опреснитель", fr: "dessalinisateur", ro: "desalinizator", pl: "odsalacz", he: "מתקן התפלה", es: "desalinizadora" },
  hatch_large: { en: "Hatch Large", el: "Hatch μεγάλο", it: "oblò grande", de: "Große Luke", ru: "большой люк", fr: "grand panneau", ro: "trapă mare", pl: "duży luk", he: "פתח גדול", es: "escotilla grande" },
  hatch_toilet: { en: "Hatch Toilet", el: "Hatch τουαλέτας", it: "oblò bagno", de: "Toiletten-Luke", ru: "люк туалета", fr: "panneau toilette", ro: "trapă toaletă", pl: "luk toalety", he: "פתח שירותים", es: "escotilla baño" },
  hatch_cabin: { en: "Hatch Cabin", el: "Hatch καμπίνας", it: "oblò cabina", de: "Kabinen-Luke", ru: "люк каюты", fr: "hublot cabine", ro: "trapă cabină", pl: "luk kabiny", he: "פתח תא", es: "escotilla camarote" },
  toilet_clogging: { en: "Toilet clogging", el: "Φραγή τουαλέτας", it: "ostruzione WC", de: "Toilettenverstopfung", ru: "засор туалета", fr: "obstruction WC", ro: "blocaj toaletă", pl: "zatkanie toalety", he: "סתימת שירותים", es: "atasco WC" },
  fore: { en: "fore", el: "πλώρη", it: "prua", de: "Bug", ru: "нос", fr: "proue", ro: "prova", pl: "dziób", he: "חרטום", es: "proa" },
  aft: { en: "aft", el: "πρύμνη", it: "poppa", de: "Heck", ru: "корма", fr: "poupe", ro: "pupa", pl: "rufa", he: "ירכתיים", es: "popa" },
  port: { en: "port", el: "αριστερά", it: "babordo", de: "Backbord", ru: "левый борт", fr: "bâbord", ro: "babord", pl: "lewa burta", he: "שמאל", es: "babor" },
  starboard: { en: "starboard", el: "δεξιά", it: "tribordo", de: "Steuerbord", ru: "правый борт", fr: "tribord", ro: "tribord", pl: "prawa burta", he: "ימין", es: "estribor" },
  dinghy: { en: "dinghy", el: "λέμβος", it: "tender", de: "Beiboot", ru: "тузик", fr: "annexe", ro: "barcă auxiliară", pl: "ponton", he: "סירת גומי", es: "bote auxiliar" },
  outboard: { en: "outboard", el: "εξωλέμβιος", it: "fuoribordo", de: "Außenborder", ru: "подвесной мотор", fr: "hors-bord", ro: "motor exterior", pl: "silnik zaburtowy", he: "מנוע חיצוני", es: "fueraborda" },
  fuel_jerrycan: { en: "fuel jerrycan", el: "κανίστρα καυσίμου", it: "tanica carburante", de: "Kraftstoffkanister", ru: "канистра для топлива", fr: "jerrycan carburant", ro: "canistră combustibil", pl: "kanister na paliwo", he: "ג'ריקן דלק", es: "bidón de combustible" },
  oars: { en: "oars", el: "κουπιά", it: "remi", de: "Ruder", ru: "вёсла", fr: "rames", ro: "vâsle", pl: "wiosła", he: "משוטים", es: "remos" },
  sea_tap: { en: "sea tap", el: "βάνα θάλασσας", it: "presa a mare", de: "Seeventil", ru: "кингстон", fr: "vanne de mer", ro: "robinet de mare", pl: "zawór denny", he: "ברז ים", es: "grifo de mar" },
};

// 🔥 MIGRATION HELPER: Προσθήκη missing keys σε saved items
const migrateItems = (savedItems, KEYS) => {
  if (!savedItems || savedItems.length === 0) return null;
  const existing = savedItems.map(it => it.key || it.id);
  const missing = KEYS.filter(k => !existing.includes(k));
  if (missing.length > 0) {
    console.log('🔄 MIGRATION Page 3: Adding missing items:', missing);
    const newItems = missing.map(key => ({ id: key, key, price: "", qty: 1, inOk: false, out: null, media: [] }));
    return [...savedItems, ...newItems];
  }
  return savedItems;
};

// 🔥 MASTER MERGE: render list = master_items keys + saved values per booking.
// Stale saved keys (no longer in master_items) are dropped. Missing keys get defaults.
// Order follows masterKeys.
const mergeWithMaster = (savedItems, masterKeys, masterValues = {}) => {
  if (!masterKeys || masterKeys.length === 0) return savedItems || [];
  const byKey = new Map((savedItems || []).map(it => [it.key || it.id, it]));
  return masterKeys.map(key => {
    const saved = byKey.get(key);
    const mv = masterValues[key];
    if (saved) {
      // 🔥 price/qty fallback σε DB ΜΟΝΟ όταν saved value είναι κενό.
      // inOk/out/media δεν επηρεάζονται — μένουν ως saved.
      const savedPriceEmpty = saved.price === "" || saved.price == null;
      const savedQtyEmpty = saved.qty === "" || saved.qty == null;
      const price = savedPriceEmpty && mv?.price != null ? String(mv.price) : saved.price;
      const qty = savedQtyEmpty && mv?.qty != null ? Number(mv.qty) : saved.qty;
      return { ...saved, key, id: saved.id || key, price, qty };
    }
    return {
      id: key, key,
      price: mv?.price != null ? String(mv.price) : "",
      qty: mv?.qty != null ? Number(mv.qty) : 1,
      inOk: false, out: null, media: [],
    };
  });
};

export default function Page2({ onNavigate }: { onNavigate?: (direction: 'next' | 'prev') => void }) {
  const [lang, setLang] = useState(sessionStorage.getItem("yacht_lang") || "en");
  const [showLangPopup, setShowLangPopup] = useState(false);

  const LANG_MAP_P2 = [
    { code: 'el', country: 'GR', label: 'Ελληνικά' },
    { code: 'en', country: 'GB', label: 'English' },
    { code: 'it', country: 'IT', label: 'Italiano' },
    { code: 'de', country: 'DE', label: 'Deutsch' },
    { code: 'ru', country: 'RU', label: 'Русский' },
    { code: 'fr', country: 'FR', label: 'Français' },
    { code: 'ro', country: 'RO', label: 'Română' },
    { code: 'pl', country: 'PL', label: 'Polski' },
    { code: 'he', country: 'IL', label: 'עברית' },
    { code: 'es', country: 'ES', label: 'Español' },
  ];

  const flagImgP2 = (countryCode: string) =>
    `https://flagcdn.com/24x18/${countryCode.toLowerCase()}.png`;

  const handleLangChange = (newLang: string) => {
    setLang(newLang);
    sessionStorage.setItem('yacht_lang', newLang);
    setShowLangPopup(false);
  };


  const t = I18N[lang] || I18N.en;
  const navigate = useNavigate();

  const contextData = useContext(DataContext);
  const [currentMode, setCurrentMode] = useState(contextData?.mode || 'in');
  const contextBookingNumber = contextData?.bookingNumber || '';
  const currentBookingNumber = contextBookingNumber || localStorage.getItem('currentBooking') || '';

  // Dynamic section catalog (loaded from master_items, page_group='page3')
  const [sectionKeys, setSectionKeys] = useState({ equipment: [], hull: [], dinghy: [], optional: [] });
  const [keysLoaded, setKeysLoaded] = useState(false);

  // 🔥 Detect booking change WITHOUT localStorage (App.tsx writes localStorage before we see context)
  const prevBookingRef = useRef(null);

  // Load canonical key list per section from master_items (one-time, global)
  useEffect(() => {
    (async () => {
      try {
        const masterItems = await getMasterItems(undefined, 'page3');
        const grouped = { equipment: [], hull: [], dinghy: [], optional: [] };
        for (const mi of (masterItems || [])) {
          if (mi.active === false) continue;
          if (grouped[mi.section]) grouped[mi.section].push(mi.item_key);
        }
        setSectionKeys(grouped);
        console.log('Dynamic Page 3: master_items loaded', grouped);
      } catch (err) {
        console.error('Dynamic Page 3: master_items load failed', err);
      } finally {
        setKeysLoaded(true);
      }
    })();
  }, []);

  // 🔥 Reset data if booking number changed (useRef-based — no localStorage; multi-tenant safe)
  useEffect(() => {
    if (!contextBookingNumber) return;
    if (prevBookingRef.current !== null && prevBookingRef.current !== contextBookingNumber) {
      console.log(`🔄 Booking changed: ${prevBookingRef.current} → ${contextBookingNumber} - RESETTING all data`);
      setItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setHullItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setDinghyItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setOptionalItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setMainsailAgreed(false);
      setDiversAgreed(false);
      setRemarks("");
      setSignatureDone(false);
      setSignatureImage("");
      setDiversImageUploaded(false);
      setDiversReportFile(null);
    }
    prevBookingRef.current = contextBookingNumber;
  }, [contextBookingNumber]);


  // Listen for mode changes from Context
  useEffect(() => {
    if (contextData?.mode && contextData.mode !== currentMode) {
      console.log(`🔄 Page2 detected mode change: ${currentMode} → ${contextData.mode}`);
      setCurrentMode(contextData.mode);
    }
  }, [contextData?.mode]);

  // Listen for mode change events
  useEffect(() => {
    const handleModeChange = (e) => {
      console.log(`📢 Page2 received modeChanged event: ${e.detail.mode}`);
      setCurrentMode(e.detail.mode);
    };
    
    window.addEventListener('modeChanged', handleModeChange);
    return () => window.removeEventListener('modeChanged', handleModeChange);
  }, []);

  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const [isEmployee, setIsEmployee] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [employeeCode, setEmployeeCode] = useState("");
  const [showEmployeeCode, setShowEmployeeCode] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [showBaseManagerModal, setShowBaseManagerModal] = useState(false);

  // 🔥 Read logged-in user (from Gate Page) on mount so role-gated sections (optional) appear without re-login
  useEffect(() => {
    let u = null;
    try { u = JSON.parse(sessionStorage.getItem('auth_current_user') || 'null'); } catch (e) { u = null; }
    if (!u) u = authService.getCurrentUser();
    console.log('🔑 Page3 mount-auth: auth_current_user =', u);
    if (u) {
      setIsEmployee(true);
      setCurrentEmployee({ ...(u.permissions || {}), role: u.role });
      console.log('🔑 Page3 set currentEmployee role =', u.role, '| canDelete =', u.permissions?.canDelete, '| permissions =', u.permissions);
    }
  }, []);

  const [mainsailAgreed, setMainsailAgreed] = useState(false);
  const [diversImageUploaded, setDiversImageUploaded] = useState(false);
  const [diversAgreed, setDiversAgreed] = useState(false);
  const [signatureDone, setSignatureDone] = useState(false);
  const [signatureImage, setSignatureImage] = useState("");
  const [remarks, setRemarks] = useState("");
  const [diversReportFile, setDiversReportFile] = useState(null);

  // 🔒 Box configs (master_boxes, page_group=page3) — source of truth for required/hide per mode.
  // handleNext must only enforce a box that is active + required + NOT hidden for the current mode,
  // exactly like terms_conditions (which is hidden+optional and therefore never blocks).
  const [boxCfg, setBoxCfg] = useState<Record<string, any>>({});

  // 🔥 FIX: Store Page 1 data for header display
  const [page1Data, setPage1Data] = useState<any>(null);

  // 🔥 FIX: Load Page 1 data for header
  useEffect(() => {
    const loadPage1Data = async () => {
      if (currentBookingNumber) {
        try {
          const data = await getPage1DataHybrid(currentBookingNumber);
          if (data) {
            console.log('📍 Page 2: Loaded Page 1 data for header:', data);
            setPage1Data(data);
          }
        } catch (error) {
          console.error('❌ Page 2: Failed to load Page 1 data:', error);
        }
      }
    };
    loadPage1Data();
  }, [currentBookingNumber]);

  // 🔒 Load page3 box configs once (GET is open to charterers — no employee code needed).
  useEffect(() => {
    let cancelled = false;
    fetch('/api/master-boxes.php?page_group=page3')
      .then((r) => r.json())
      .then((j) => {
        if (cancelled || !j || !j.success || !Array.isArray(j.boxes)) return;
        const map: Record<string, any> = {};
        for (const b of j.boxes) { if (b && b.box_key) map[b.box_key] = b; }
        setBoxCfg(map);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Truthy helper for Postgres/JSON booleans (true | 't' | 'true' | 1).
  const isTrueFlag = (v: any) => v === true || v === 't' || v === 'true' || v === 1 || v === '1';

  // A box gates handleNext ONLY when it is active + required + visible for the current mode.
  // Unknown config (not yet loaded / missing row) → NOT enforced, so we never block silently.
  const boxEnforced = (key: string): boolean => {
    const cfg = boxCfg[key];
    if (!cfg) return false;
    if (!isTrueFlag(cfg.active)) return false;
    if (!isTrueFlag(cfg.required)) return false;
    const hidden = mode === 'in' ? isTrueFlag(cfg.hide_checkin) : isTrueFlag(cfg.hide_checkout);
    return !hidden;
  };

  // Translated box title from DB config (falls back to EN, then the key).
  const boxTitle = (key: string): string => {
    const cfg = boxCfg[key];
    if (!cfg) return key;
    return cfg['title_' + lang] || cfg.title_en || key;
  };

  const mainsailRef = useRef(null);
  const diversReportRef = useRef(null);
  const diversAgreementRef = useRef(null);
  const signatureRef = useRef(null);

  // 🔥 ΧΡΗΣΙΜΟΠΟΙΟΥΜΕ ΑΠΕΥΘΕΙΑΣ ΤΟ currentMode (ΟΧΙ local state!)
  const mode = currentMode;

  // 🟡 CHECK-IN PREVIEW — σήμερα < ημέρα check-in ΚΑΙ mode='in' → τίποτα δεν σώζεται
  // (καλύπτει και το auto-save/2s, που περνάει από savePage3DataHybrid).
  //
  // 🔎 ΗΜΕΡΟΜΗΝΙΕΣ: το page1Data έρχεται async (getPage1DataHybrid) και μπορεί να αργήσει
  // ή να αποτύχει. Γι' αυτό οι ημερομηνίες λύνονται από ΑΛΥΣΙΔΑ πηγών:
  //   page1Data → contextData.globalBookings (match booking) → contextData.data
  // Ίδια αλυσίδα με το bookingInfo του render (γρ. ~1160), αλλά διαθέσιμη ΚΑΙ στο handleNext.
  const resolvePreviewDates = () => {
    const gb = contextData?.globalBookings || [];
    const fromCtx = gb.find((b: any) => b.bookingNumber === currentBookingNumber || b.code === currentBookingNumber)
      || contextData?.data || {};
    return {
      checkInDate: page1Data?.checkInDate || fromCtx?.checkInDate,
      checkOutDate: page1Data?.checkOutDate || fromCtx?.checkOutDate,
    };
  };

  const [isPreview, setIsPreview] = useState(false);
  useEffect(() => {
    const d = resolvePreviewDates();
    // Χωρίς ΚΑΜΙΑ γνωστή ημερομηνία μην πειράζεις το module flag — το έχει ήδη θέσει
    // σωστά η σελίδα 2 (ο customer πάντα περνάει από εκεί). Αλλιώς θα το μηδενίζαμε.
    if (!d.checkInDate) return;
    setIsPreview(syncCheckinPreview(d.checkInDate, d.checkOutDate, mode));
  }, [page1Data?.checkInDate, page1Data?.checkOutDate, currentBookingNumber, contextData?.globalBookings, contextData?.data, mode]);

  /**
   * Φρέσκια τιμή preview τη στιγμή του κλικ — ΔΕΝ βασίζεται μόνο στο state.
   * 3 πηγές, με σειρά: (1) το state, (2) το module flag που έθεσε η σελ.2,
   * (3) φρέσκος υπολογισμός από την αλυσίδα ημερομηνιών.
   * Αν καμία πηγή δεν δίνει preview → false → validation ΚΑΝΟΝΙΚΑ (fail-safe).
   */
  const previewNow = (): boolean => {
    if (isPreview) return true;
    if (isCheckinPreview()) return true;
    const d = resolvePreviewDates();
    return computeCheckinPreview(d.checkInDate, d.checkOutDate, mode);
  };

  const [items, setItems] = useState([]);
  const [hullItems, setHullItems] = useState([]);
  const [dinghyItems, setDinghyItems] = useState([]);
  const [optionalItems, setOptionalItems] = useState([]);

  // 🔒 SNAPSHOT freeze (page4 parity): once page5_agreement.items_snapshot.page3 exists
  // for this (booking, mode), the page becomes read-only via TableSection's readOnly prop.
  // Detection only — does NOT hydrate from snapshot (live data remains source of truth).
  const [isFrozen, setIsFrozen] = useState(false);
  useEffect(() => {
    const bn = contextData?.bookingNumber || (typeof window !== 'undefined' ? localStorage.getItem('currentBooking') : null);
    const m = (contextData?.mode || 'in') as 'in' | 'out';
    if (!bn) { setIsFrozen(false); return; }
    let cancelled = false;
    (async () => {
      try {
        const ag = await getPage5Agreement(bn);
        if (cancelled) return;
        const row = m === 'in' ? ag?.checkIn : ag?.checkOut;
        const snap = row?.items_snapshot?.page3;
        const hasItems = snap && typeof snap === 'object' &&
          Object.values(snap).some((arr: any) => Array.isArray(arr) && arr.length > 0);
        let coDateP3 = '';
        let coTimeP3 = '';
        try {
          const p1y = await getPage1DataHybrid(bn);
          coDateP3 = (p1y as any)?.checkOutDate || '';
          coTimeP3 = (p1y as any)?.checkOutTime || '';
        } catch (eP1y) { coDateP3 = ''; coTimeP3 = ''; }
        const submittedP3 = !!hasItems && row?.email_sent === true;
        // FAIL-SAFE: unknown checkout date -> freeze (old behavior). Known -> freeze only after end+1h (Athens).
        setIsFrozen(submittedP3 && (!coDateP3 || isPastCheckoutGrace(coDateP3, coTimeP3, 1)));
      } catch (e) {
        console.warn('Page 3 snapshot check failed (treating as not frozen):', e);
        if (!cancelled) setIsFrozen(false);
      }
    })();
    return () => { cancelled = true; };
  }, [contextData?.bookingNumber, contextData?.mode]);
  // 🔥 yacht_items DB defaults map {item_key: {price, qty}}.
  // Fallback ΜΟΝΟ στα missing keys στη mergeWithMaster (saved values υπερισχύουν).
  const [masterValues, setMasterValues] = useState({});

  // 🔥 PHASE 3: Load items from yacht_items DB per vessel
  useEffect(() => {
    if (!keysLoaded) return;
    const vName = (page1Data?.vesselName || contextData?.data?.vesselName || '').toLowerCase().trim();
    if (!vName) return;

    const vesselId = VESSEL_NAME_TO_ID[vName];
    if (!vesselId) {
      console.warn('Phase 3 Page 3: Unknown vessel', vName);
      return;
    }

    const SECTION_TO_SETTER = {
      equipment: setItems,
      hull: setHullItems,
      dinghy: setDinghyItems,
      optional: setOptionalItems,
    };

    const SECTION_FALLBACK_KEYS = {
      equipment: sectionKeys.equipment,
      hull: sectionKeys.hull,
      dinghy: sectionKeys.dinghy,
      optional: sectionKeys.optional,
    };

    const inlineInit = (keys) => keys.map(key => ({
      id: uid(), key, price: "", qty: 1, inOk: false, out: null, media: []
    }));

    (async () => {
      try {
        // 🔥 FETCH FIRST: yacht_items must always be loaded to populate
        // masterValues map (used by mergeWithMaster fallback for missing keys).
        // include_inactive=true: rawGrouped distinguishes "DB-managed" from "never seeded".
        const yachtItems = await getYachtItems(vesselId, undefined, true);
        const activeItems = (yachtItems || []).filter(yi => yi.active);

        // Populate masterValues from active yacht_items (price/qty per key).
        const mvMap = {};
        for (const yi of activeItems) {
          mvMap[yi.item_key] = { price: yi.price, qty: yi.qty };
        }
        setMasterValues(mvMap);

        // GUARD: Skip setting items state from defaults if saved data exists
        // (masterValues is already populated above for downstream merge fallback).
        const bookingNumber = page1Data?.bookingNumber || contextData?.data?.bookingNumber || contextData?.bookingNumber;
        if (bookingNumber) {
          try {
            const savedData = await getPage3DataHybrid(bookingNumber, mode);
            if (savedData && savedData.items && savedData.items.length > 0) {
              console.log('✋ Phase 3 Page 3: Skipping yacht_items defaults — saved data exists');
              return;
            }
          } catch (e) {
            console.warn('Phase 3 Page 3: guard check failed, proceeding with defaults', e);
          }
        }

        const grouped = { equipment: [], hull: [], dinghy: [], optional: [] };
        // Raw grouping (active+inactive) — distinguishes "section is DB-managed" from "never seeded"
        const rawGrouped = { equipment: [], hull: [], dinghy: [], optional: [] };
        for (const yi of (yachtItems || [])) {
          if (rawGrouped[yi.section]) rawGrouped[yi.section].push(yi);
        }

        for (const yi of activeItems) {
          if (grouped[yi.section]) {
            grouped[yi.section].push({
              id: uid(),
              key: yi.item_key,
              price: yi.price != null ? String(yi.price) : "",
              qty: yi.qty != null ? Number(yi.qty) : 1,
              inOk: false,
              out: null,
              media: []
            });
          }
        }

        // Fallback ONLY when section has zero rows in DB (never seeded).
        // If admin unchecked all items → respect empty list.
        // Also rewrite sectionKeys per-vessel so downstream mergeWithMaster()
        // doesn't reintroduce inactive items from the cross-vessel master_items list.
        const vesselSectionKeys = {};
        for (const section of Object.keys(SECTION_TO_SETTER)) {
          const setter = SECTION_TO_SETTER[section];
          if (rawGrouped[section].length > 0) {
            setter(grouped[section]);
            vesselSectionKeys[section] = activeItems
              .filter(yi => yi.section === section)
              .map(yi => yi.item_key);
          } else {
            setter(inlineInit(SECTION_FALLBACK_KEYS[section]));
          }
        }
        if (Object.keys(vesselSectionKeys).length > 0) {
          setSectionKeys(prev => ({ ...prev, ...vesselSectionKeys }));
        }

        console.log('🔥 Phase 3 Page 3: Loaded items from DB for vessel', vName, 'vessel_id', vesselId);
      } catch (err) {
        console.warn('⚠️ Phase 3 Page 3: yacht_items API failed, using hardcoded fallback:', err);
        setItems(inlineInit(sectionKeys.equipment));
        setHullItems(inlineInit(sectionKeys.hull));
        setDinghyItems(inlineInit(sectionKeys.dinghy));
        setOptionalItems(inlineInit(sectionKeys.optional));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page1Data?.vesselName, contextData?.data?.vesselName, keysLoaded, currentBookingNumber]);
  // 🔥 END PHASE 3

  // 🔥 BUG 1 FIX: Reset mode-non-specific flags on mode change to prevent Select All carry-over
  // Also reset items.out to null when switching to check-out (load useEffect will populate from storage if exists)
  useEffect(() => {
    setMainsailAgreed(false);
    setDiversAgreed(false);
    setDiversImageUploaded(false);
    setDiversReportFile(null);
    if (mode === 'out') {
      // Reset out field on switch to check-out (inOk inherits from check-in for reference column)
      setItems(prev => prev.map(it => ({ ...it, out: null })));
      setHullItems(prev => prev.map(it => ({ ...it, out: null })));
      setDinghyItems(prev => prev.map(it => ({ ...it, out: null })));
    }
  }, [mode]);

  useEffect(() => {
    if (!keysLoaded) return;
    console.log(`🚀🚀🚀 SIGNATURE useEffect TRIGGERED! mode=${mode}, booking=${currentBookingNumber}`);

    if (currentBookingNumber) {
      // 🔥 Load from API first, then localStorage fallback
      const loadData = async () => {
        try {
          // 🔥 FIX: When in check-out mode, first load check-in data to get inOk values
          let checkInItems = null;
          let checkInHullItems = null;
          let checkInDinghyItems = null;
          let checkInOptionalItems = null;

          if (mode === 'out') {
            // Load check-in data first to get inOk status
            const checkInData = await getPage3DataHybrid(currentBookingNumber, 'in');
            if (checkInData) {
              checkInItems = checkInData.items;
              checkInHullItems = checkInData.hullItems;
              checkInDinghyItems = checkInData.dinghyItems;
              checkInOptionalItems = checkInData.optionalItems;
              console.log('✅ Check-in data loaded for inOk values');
            } else {
              // Fallback to localStorage
              const savedCheckIn = loadBookingData(currentBookingNumber, 'in');
              if (savedCheckIn) {
                checkInItems = savedCheckIn.items;
                checkInHullItems = savedCheckIn.hullItems;
                checkInDinghyItems = savedCheckIn.dinghyItems;
                checkInOptionalItems = savedCheckIn.optionalItems;
              }
            }
          }

          const apiData = await getPage3DataHybrid(currentBookingNumber, mode);

          // Helper function to merge inOk from check-in data with current mode data
          const mergeInOkData = (currentItems, checkInItemsData, defaultKeys) => {
            if (!currentItems && !checkInItemsData) return null;

            // If we have current mode items, merge inOk from check-in
            if (currentItems && checkInItemsData) {
              return currentItems.map(item => {
                const checkInItem = checkInItemsData.find(ci => ci.key === item.key);
                return { ...item, inOk: checkInItem?.inOk || item.inOk || false, problematic: checkInItem?.problematic || false };
              });
            }

            // If only check-in items exist (starting checkout), use them as base — preserve inOk for reference
            if (checkInItemsData) {
              return checkInItemsData.map(item => ({ ...item, out: null }));
            }

            return currentItems;
          };

          if (apiData) {
            console.log('✅ Page 2 data loaded from API');
            const eqAfterInOk = mode === 'out' ? mergeInOkData(apiData.items, checkInItems, sectionKeys.equipment) : apiData.items;
            const hullAfterInOk = mode === 'out' ? mergeInOkData(apiData.hullItems, checkInHullItems, sectionKeys.hull) : apiData.hullItems;
            const dinghyAfterInOk = mode === 'out' ? mergeInOkData(apiData.dinghyItems, checkInDinghyItems, sectionKeys.dinghy) : apiData.dinghyItems;
            const optionalAfterInOk = mode === 'out' ? mergeInOkData(apiData.optionalItems, checkInOptionalItems, sectionKeys.optional) : apiData.optionalItems;

            const mergedItems = mergeWithMaster(eqAfterInOk, sectionKeys.equipment, masterValues);
            const mergedHullItems = mergeWithMaster(hullAfterInOk, sectionKeys.hull, masterValues);
            const mergedDinghyItems = mergeWithMaster(dinghyAfterInOk, sectionKeys.dinghy, masterValues);
            const mergedOptionalItems = mergeWithMaster(optionalAfterInOk, sectionKeys.optional, masterValues);

            if (mergedItems) setItems(mergedItems);
            if (mergedHullItems) setHullItems(mergedHullItems);
            if (mergedDinghyItems) setDinghyItems(mergedDinghyItems);
            if (mergedOptionalItems) setOptionalItems(mergedOptionalItems);
            if (apiData.mainsailAgreed !== undefined) setMainsailAgreed(apiData.mainsailAgreed);
            if (apiData.diversAgreed !== undefined) setDiversAgreed(apiData.diversAgreed);
            if (apiData.diversReport !== undefined) {
              setDiversReportFile(apiData.diversReport);
              setDiversImageUploaded(!!apiData.diversReport);
            }
            if (apiData.remarks !== undefined) setRemarks(apiData.remarks);
          } else {
            // Fallback to localStorage via shared function
            const savedData = loadBookingData(currentBookingNumber, mode);
            if (savedData) {
              const eqAfterInOk = mode === 'out' ? mergeInOkData(savedData.items, checkInItems, sectionKeys.equipment) : savedData.items;
              const hullAfterInOk = mode === 'out' ? mergeInOkData(savedData.hullItems, checkInHullItems, sectionKeys.hull) : savedData.hullItems;
              const dinghyAfterInOk = mode === 'out' ? mergeInOkData(savedData.dinghyItems, checkInDinghyItems, sectionKeys.dinghy) : savedData.dinghyItems;
              const optionalAfterInOk = mode === 'out' ? mergeInOkData(savedData.optionalItems, checkInOptionalItems, sectionKeys.optional) : savedData.optionalItems;

              const mergedItems = mergeWithMaster(eqAfterInOk, sectionKeys.equipment, masterValues);
              const mergedHullItems = mergeWithMaster(hullAfterInOk, sectionKeys.hull, masterValues);
              const mergedDinghyItems = mergeWithMaster(dinghyAfterInOk, sectionKeys.dinghy, masterValues);
              const mergedOptionalItems = mergeWithMaster(optionalAfterInOk, sectionKeys.optional, masterValues);

              if (mergedItems) setItems(mergedItems);
              if (mergedHullItems) setHullItems(mergedHullItems);
              if (mergedDinghyItems) setDinghyItems(mergedDinghyItems);
              if (mergedOptionalItems) setOptionalItems(mergedOptionalItems);
              if (savedData.mainsailAgreed !== undefined) setMainsailAgreed(savedData.mainsailAgreed);
              if (savedData.diversAgreed !== undefined) setDiversAgreed(savedData.diversAgreed);
              if (savedData.remarks !== undefined) setRemarks(savedData.remarks);
            } else if (mode === 'out' && (checkInItems || checkInHullItems || checkInDinghyItems || checkInOptionalItems)) {
              // No check-out data yet, but we have check-in data - use it as starting point
              console.log('🔄 Using check-in data as base for check-out');
              // inOk inherits from check-in (for Check-IN read-only reference column)
              if (checkInItems) setItems(mergeWithMaster(checkInItems.map(item => ({ ...item, out: null })), sectionKeys.equipment, masterValues));
              if (checkInHullItems) setHullItems(mergeWithMaster(checkInHullItems.map(item => ({ ...item, out: null })), sectionKeys.hull, masterValues));
              if (checkInDinghyItems) setDinghyItems(mergeWithMaster(checkInDinghyItems.map(item => ({ ...item, out: null })), sectionKeys.dinghy, masterValues));
              if (checkInOptionalItems) setOptionalItems(mergeWithMaster(checkInOptionalItems.map(item => ({ ...item, out: null })), sectionKeys.optional, masterValues));
            }
          }
        } catch (error) {
          console.warn('⚠️ API load failed, using localStorage:', error);
          const savedData = loadBookingData(currentBookingNumber, mode);
          if (savedData) {
            if (savedData.items) setItems(mergeWithMaster(savedData.items, sectionKeys.equipment, masterValues));
            if (savedData.hullItems) setHullItems(mergeWithMaster(savedData.hullItems, sectionKeys.hull, masterValues));
            if (savedData.dinghyItems) setDinghyItems(mergeWithMaster(savedData.dinghyItems, sectionKeys.dinghy, masterValues));
            if (savedData.optionalItems) setOptionalItems(mergeWithMaster(savedData.optionalItems, sectionKeys.optional, masterValues));
            if (savedData.mainsailAgreed !== undefined) setMainsailAgreed(savedData.mainsailAgreed);
            if (savedData.diversAgreed !== undefined) setDiversAgreed(savedData.diversAgreed);
            if (savedData.remarks !== undefined) setRemarks(savedData.remarks);
          }
        }
      };
      loadData();

      // 🔥 ΣΗΜΑΝΤΙΚΟ: Φορτώνει υπογραφή με το ΣΩΣΤΟ mode
      const signatureKey = `page2_signature_${currentBookingNumber}_${mode}`;
      const savedSignature = localStorage.getItem(signatureKey);

      console.log(`🔍 Loading signature for mode: ${mode}, key: ${signatureKey}`);

      if (savedSignature) {
        console.log(`✅ Signature found for ${mode}`);
        setSignatureImage(savedSignature);
        setSignatureDone(true);
      } else {
        console.log(`❌ No signature found for ${mode} - clearing`);
        setSignatureImage("");
        setSignatureDone(false);
      }

    }
  }, [currentBookingNumber, mode, keysLoaded, sectionKeys, masterValues]);

  useEffect(() => {
    if (!currentBookingNumber) return;
    
    const autoSaveTimeout = setTimeout(() => {
      const dataToSave = {
        items, hullItems, dinghyItems, optionalItems: optionalItems, mainsailAgreed,
        diversAgreed, remarks,
        diversReport: diversReportFile
      };
      savePage3DataHybrid(currentBookingNumber, dataToSave, mode).catch((e) => console.warn('Auto-save error:', e));
      console.log('💾 Auto-saved!');
    }, 2000);

    return () => clearTimeout(autoSaveTimeout);
  }, [items, hullItems, dinghyItems, optionalItems, mainsailAgreed, diversAgreed, remarks, diversReportFile, currentBookingNumber, mode]);

  // 🔥 ΔΙΑΓΡΑΦΗΚΕ: Δεν χρειάζεται πια γιατί το mode ΔΕΝ είναι state!

  const [newItem, setNewItem] = useState("");
  const [camForId, setCamForId] = useState(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const fileInputRef = useRef(null);
  const [zoomUrl, setZoomUrl] = useState(null);
  const [pendingFlashItemId, setPendingFlashItemId] = useState(null);
  const [pendingFlashTable, setPendingFlashTable] = useState(null);

  // Flash effect for incomplete item
  useEffect(() => {
    if (pendingFlashItemId && pendingFlashTable) {
      console.log('🎯 useEffect triggered! Looking for item:', pendingFlashItemId, 'in table:', pendingFlashTable);
      
      setTimeout(() => {
        const row = document.querySelector(`[data-item-id="${pendingFlashItemId}"]`);
        console.log('📍 Found row in useEffect:', row);
        
        if (row) {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          row.style.backgroundColor = '#fee2e2';
          row.style.transition = 'background-color 0.3s';
          setTimeout(() => {
            row.style.backgroundColor = '';
          }, 4000);
        } else {
          console.error('❌ Row not found! Item ID:', pendingFlashItemId);
        }
        
        setPendingFlashItemId(null);
        setPendingFlashTable(null);
      }, 100);
    }
  }, [pendingFlashItemId, pendingFlashTable]);

  const getLabel = (key) => ITEM_LABELS[key]?.[lang] || ITEM_LABELS[key]?.['en'] || key;

  const totalItems = items.length + hullItems.length + dinghyItems.length;
  let completedItems = 0;
  if (mode === "in") {
    completedItems = [...items, ...hullItems, ...dinghyItems].filter((it) => it.inOk).length;
  } else {
    completedItems = [...items, ...hullItems, ...dinghyItems].filter((it) => it.out === "ok" || it.out === "not").length;
  }
  const percentage = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

  const addNewItem = () => {
    if (!newItem.trim()) {
      alert(t.enterItemName || 'Enter item name!');
      return;
    }
    setItems([...items, { id: uid(), key: newItem, price: "", qty: 1, inOk: false, out: null, media: [] }]);
    setNewItem("");
  };

  const setPrice = (id, val) => {
    const set = (prev) => prev.map((it) => (it.id === id ? { ...it, price: val } : it));
    setItems((prev) => set(prev));
    setHullItems((prev) => set(prev));
    setDinghyItems((prev) => set(prev));
    setOptionalItems((prev) => set(prev));
  };

  const incQty = (id) => {
    const inc = (prev) => prev.map((it) => (it.id === id ? { ...it, qty: (it.qty || 1) + 1 } : it));
    setItems((prev) => inc(prev));
    setHullItems((prev) => inc(prev));
    setDinghyItems((prev) => inc(prev));
    setOptionalItems((prev) => inc(prev));
  };

  const decQty = (id) => {
    const dec = (prev) => prev.map((it) => (it.id === id && (it.qty || 1) > 1 ? { ...it, qty: (it.qty || 1) - 1 } : it));
    setItems((prev) => dec(prev));
    setHullItems((prev) => dec(prev));
    setDinghyItems((prev) => dec(prev));
    setOptionalItems((prev) => dec(prev));
  };

  const toggleInOk = (id) => {
    const toggle = (prev) => prev.map((it) => (it.id === id ? { ...it, inOk: !it.inOk } : it));
    setItems((prev) => toggle(prev));
    setHullItems((prev) => toggle(prev));
    setDinghyItems((prev) => toggle(prev));
    setOptionalItems((prev) => toggle(prev));
  };

  const setOut = (id, val) => {
    const set = (prev) => prev.map((it) => (it.id === id ? { ...it, out: val } : it));
    setItems((prev) => set(prev));
    setHullItems((prev) => set(prev));
    setDinghyItems((prev) => set(prev));
    setOptionalItems((prev) => set(prev));
  };
  const openCamera = (id) => {
    setCamForId(id);
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
      .then((stream) => {
        streamRef.current = stream;
        if (videoRef.current) videoRef.current.srcObject = stream;
      })
      .catch((err) => {
        console.error('Camera error:', err);
        alert(t.cameraError || 'Could not open camera');
      });
  };

  const closeCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    setCamForId(null);
  };

  const capturePhoto = async () => {
    const video = videoRef.current;
    if (!video) return;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(video, 0, 0);
    try {
      const base64 = canvas.toDataURL('image/jpeg', 0.8);
      const compressed = await compressImageWithLogging(base64);
      attachMedia(camForId, { mid: mid(), type: 'img', url: compressed });
      closeCamera();
    } catch (error) {
      console.error('Error capturing photo:', error);
      alert('Error capturing photo. Please try again.');
    }
  };

  const openFilePicker = (id) => {
    setCamForId(id);
    fileInputRef.current?.click();
  };

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length || !camForId) return;
    for (const file of files) {
      if (file.type.startsWith('image/')) {
        try {
          const base64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
          const compressed = await compressImageWithLogging(base64);
          attachMedia(camForId, { mid: mid(), type: 'img', url: compressed });
        } catch (error) {
          console.error('Error processing image:', error);
          alert('Error processing image. Please try again.');
        }
      } else {
        attachMedia(camForId, { mid: mid(), type: 'file', name: file.name });
      }
    }
    e.target.value = '';
    setCamForId(null);
  };

  const attachMedia = (id, mediaObj) => {
    const add = (prev) => prev.map((it) => (it.id === id ? { ...it, media: [...(it.media || []), mediaObj] } : it));
    setItems((prev) => add(prev));
    setHullItems((prev) => add(prev));
    setDinghyItems((prev) => add(prev));
    setOptionalItems((prev) => add(prev));
  };

  const removeRow = (id) => {
    if (!isEmployee || !currentEmployee?.canDelete) {
      alert(t.employeeRequired || '🔒 Employee permissions required!');
      return;
    }
    if (!window.confirm(t.deleteItemConfirm || 'Delete item?')) return;
    setItems((prev) => prev.filter((it) => it.id !== id));
    setHullItems((prev) => prev.filter((it) => it.id !== id));
    setDinghyItems((prev) => prev.filter((it) => it.id !== id));
    setOptionalItems((prev) => prev.filter((it) => it.id !== id));
  };

  const mediaCards = [];
  const collectMedia = (arr) => {
    arr.forEach(({ key, media, id }) => {
      (media || []).forEach((m, i) => {
        mediaCards.push({ m, i, key, id });
      });
    });
  };
  collectMedia(items);
  collectMedia(hullItems);
  collectMedia(dinghyItems);

  const removeMedia = (itemId, ref) => {
    const purge = (prev) =>
      prev.map((it) =>
        it.id === itemId ? {
          ...it,
          media: (it.media || []).filter(
            (x) => !((ref?.mid && x?.mid === ref.mid) || (ref?.url && x?.url === ref.url) || (ref?.name && x?.name === ref.name))
          ),
        } : it
      );
    setItems((prev) => purge(prev));
    setHullItems((prev) => purge(prev));
    setDinghyItems((prev) => purge(prev));
    setOptionalItems((prev) => purge(prev));
  };

  const handleEmployeeLogin = () => {
    const user = authService.login(employeeCode);
    if (user) {
      setCurrentEmployee({ ...user.permissions, role: user.role });
      setIsEmployee(true);
      setShowLoginModal(false);
      setEmployeeCode("");
      alert(`${t.welcomeUser || 'Welcome'} ${user.name}!`);
    } else {
      alert(t.wrongCode || 'Wrong code!');
    }
  };

  const handleEmployeeLogout = () => {
    authService.logout();
    setIsEmployee(false);
    setCurrentEmployee(null);
    alert(t.loggedOut || 'Logged out!');
  };

  const highlightError = (ref) => {
    if (ref?.current) {
      ref.current.style.backgroundColor = '#fee2e2';
      ref.current.style.transition = 'background-color 0.3s';
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => { ref.current.style.backgroundColor = ''; }, 4000);
    }
  };

  const handleSaveDraft = async () => {
    if (!currentBookingNumber) {
      alert(t.noActiveBooking || '❌ No active booking!');
      return;
    }

    const dataToSave = {
      items, hullItems, dinghyItems, optionalItems: optionalItems, mainsailAgreed,
      diversAgreed, remarks,
      diversReport: diversReportFile
    };

    // ✅ Save to Page 2 API using hybrid function
    try {
      const result = await savePage3DataHybrid(currentBookingNumber, dataToSave, mode);


      // 🔥 Save media to localStorage separately (API may not store large base64 images)
      savePageMedia(currentBookingNumber, mode, 'page2', [...items, ...hullItems, ...dinghyItems]);

      if (result.synced) {
        alert(t.draftSavedSynced || '✅ Draft saved and synced!');
      } else {
        alert(t.draftSavedLocally || '✅ Draft saved locally!');
      }
    } catch (error) {
      console.error('Error saving:', error);
      alert(t.saveError || '❌ Save error!');
    }
  };

  const handleSelectAllOk = () => {
    const confirmed = window.confirm(t.selectAllOkConfirm || 'Under my own responsibility I declare all items are correct. Continue?');
    if (!confirmed) return;
    if (mode === 'in') {
      setItems(prev => prev.map(it => ({ ...it, inOk: true })));
      setHullItems(prev => prev.map(it => ({ ...it, inOk: true })));
      setDinghyItems(prev => prev.map(it => ({ ...it, inOk: true })));
    } else {
      setItems(prev => prev.map(it => ({ ...it, out: 'ok' })));
      setHullItems(prev => prev.map(it => ({ ...it, out: 'ok' })));
      setDinghyItems(prev => prev.map(it => ({ ...it, out: 'ok' })));
    }
    setMainsailAgreed(true);
    setDiversAgreed(true);
    setDiversImageUploaded(true);
    setDiversReportFile("auto-accepted-via-select-all-ok");
  };

  const handleNext = async () => {
    // 🟡 CUSTOMER PREVIEW (πριν την ημέρα του ναύλου, mode='in'): ΟΛΑ τα validations
    // παρακάμπτονται — είναι δοκιμή και δεν σώζεται τίποτα. Την ημέρα του ναύλου
    // (preview=false) ισχύουν ΚΑΝΟΝΙΚΑ. Υπολογίζεται μία φορά εδώ, φρέσκο.
    const preview = previewNow();

    // 🔒 Charterer guard: Page 4 (technical_check) must have ≥1 OK from employee before charterer proceeds.
    // Employees (ADMIN/TECHNICAL/BOOKING/ACCOUNTING) bypass. API failure → block (safer).
    // 🟡 Preview: πριν τον ναύλο το τεχνικό δεν έχει γίνει ποτέ → δεν μπλοκάρει τη δοκιμή.
    if (!isEmployee && currentBookingNumber && !preview) {
      try {
        const page4 = await getPage4DataHybrid(currentBookingNumber, mode as 'in' | 'out');
        const tcItems = (page4 && page4.technicalCheckItems) || [];
        const anyOk = mode === 'in'
          ? tcItems.some((it: any) => it.inOk === true)
          : tcItems.some((it: any) => it.out === 'ok' || it.out === 'not');
        if (!anyOk) {
          setShowBaseManagerModal(true);
          return;
        }
      } catch (e) {
        console.error('Page 4 status check failed:', e);
        setShowBaseManagerModal(true);
        return;
      }
    }

    // Only enforce a box that is active + required + visible for THIS mode (DB-driven).
    // Hidden/optional boxes (e.g. mainsail_genoa, hidden+optional both modes) are skipped,
    // exactly like terms_conditions — they can never be accepted when hidden, so they must not block.
    // 🟡 Preview: όλα optional — ο πελάτης περνάει ελεύθερα.
    if (!preview) {
      if (boxEnforced('mainsail_genoa') && !mainsailAgreed) {
        alert((t.pleaseComplete || '⚠ Please complete:') + ' ' + boxTitle('mainsail_genoa'));
        highlightError(mainsailRef);
        return;
      }

      if (boxEnforced('divers_report') && !diversImageUploaded) {
        alert((t.pleaseComplete || '⚠ Please complete:') + ' ' + boxTitle('divers_report'));
        highlightError(diversReportRef);
        return;
      }

      if (boxEnforced('divers_agreement') && !diversAgreed) {
        alert((t.pleaseComplete || '⚠ Please complete:') + ' ' + boxTitle('divers_agreement'));
        highlightError(diversAgreementRef);
        return;
      }
    }

    if (SHOW_PER_PAGE_SIGNATURES && !signatureDone) {
      highlightError(signatureRef);
      return;
    }

    const dataToSave = {
      items, hullItems, dinghyItems, optionalItems: optionalItems, mainsailAgreed,
      diversAgreed, remarks,
      diversReport: diversReportFile
    };

    // 🟡 PREVIEW: η ΔΟΚΙΜΗ σταματά στη σελίδα 3. Οι σελίδες 4-5 δεν έχουν preview guard
    // (δεν τις αγγίζουμε), οπότε δεν επιτρέπουμε να προχωρήσει και να υποβάλει κανονικά.
    // ⚠️ ΙΔΙΑ τιμή `preview` με τα bypasses παραπάνω — αλλιώς θα παρακάμπταμε validation
    // και μετά θα προχωρούσαμε κανονικά στη σελ.4.
    if (preview) {
      alert(t.contactBaseManagerTech || 'Please contact the base manager.');
      return;
    }

    try {
      await savePage3DataHybrid(currentBookingNumber, dataToSave, mode);
      savePageMedia(currentBookingNumber, mode, 'page2', [...items, ...hullItems, ...dinghyItems]);

      if (onNavigate && typeof onNavigate === 'function') {
        onNavigate('next');
      } else {
        navigate('/page5');
      }
    } catch (error) {
      alert(t.saveError || 'Save error!');
    }
  };

  const handlePrevious = () => {
    handleSaveDraft();
    navigate('/page2');
  };


  const handleGeneratePDF = async () => {
    if (!currentBookingNumber) {
      alert(t.noActiveBooking || '❌ No active booking!');
      return;
    }

    const { generateLuxuryPDF } = await import('./utils/LuxuryPDFGenerator');

    // Get booking info from context (API is source of truth)
    const globalBookings = contextData?.globalBookings || [];
    const bookingFromContext = globalBookings.find((b: any) =>
      b.bookingNumber === currentBookingNumber || b.code === currentBookingNumber
    );
    const bookingInfo = bookingFromContext || contextData?.data || {};

    const bookingData = {
      bookingNumber: currentBookingNumber,
      selectedVessel: bookingInfo?.vesselName,
      skipperFirstName: bookingInfo?.skipperFirstName,
      skipperLastName: bookingInfo?.skipperLastName,
      skipperEmail: bookingInfo?.skipperEmail,
      skipperPhone: bookingInfo?.skipperPhone,
      skipperAddress: bookingInfo?.skipperAddress,
      checkInDate: bookingInfo?.checkInDate,
      checkInTime: bookingInfo?.checkInTime,
      checkOutDate: bookingInfo?.checkOutDate,
      checkOutTime: bookingInfo?.checkOutTime
    };

    const equipmentData = items.map(item => ({
      name: getLabel(item.key),
      quantity: item.qty || 1,
      price: item.price || 0,
      checkInOk: item.inOk,
      checkOutOk: item.out === 'ok',
      checkOutNotOk: item.out === 'not'
    }));

    const hullData = hullItems.map(item => ({
      area: getLabel(item.key),
      quantity: item.qty || 1,
      price: item.price || 0,
      checkInOk: item.inOk,
      checkOutOk: item.out === 'ok',
      checkOutNotOk: item.out === 'not'
    }));

    const dinghyData = dinghyItems.map(item => ({
      name: getLabel(item.key),
      quantity: item.qty || 1,
      price: item.price || 0,
      checkInOk: item.inOk,
      checkOutOk: item.out === 'ok',
      checkOutNotOk: item.out === 'not'
    }));

    // 🔥 CORRECTED: Only Check-out has damages, Check-in has pre-existing photos only
    const damages = [];
    if (mode === 'out') {
      [...items, ...hullItems, ...dinghyItems].forEach(item => {
        if (item.out === 'not') {
          damages.push({
            title: getLabel(item.key),
            quantity: item.qty || 1,
            unitPrice: item.price || 0,
            price: (item.qty || 1) * (item.price || 0)
          });
        }
      });
    }

    const photosByItem = {};
    mediaCards.forEach(card => {
      const itemLabel = getLabel(card.key);
      if (!photosByItem[itemLabel]) photosByItem[itemLabel] = [];
      if (card.m?.url) photosByItem[itemLabel].push(card.m.url);
    });

    const additionalData = {
      equipment: equipmentData,
      hull: hullData,
      dinghy: dinghyData,
      damages,
      remarks,
      photos: photosByItem,
      diversReport: diversReportFile,
      agreements: { mainsail: mainsailAgreed, divers: diversAgreed },
      skipperSignature: signatureImage,
      employeeSignature: mode === 'out' ? signatureImage : null
    };

    const doc = generateLuxuryPDF(bookingData, mode, additionalData, lang, { 
      isPage1: false,
      pageType: 'page2' 
    });
    
    doc.save(`Page2_${mode === 'in' ? 'CheckIn' : 'CheckOut'}_${currentBookingNumber}_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  // Get booking info from context (API is source of truth)
  const renderGlobalBookings = contextData?.globalBookings || [];
  const renderBookingFromContext = renderGlobalBookings.find((b: any) =>
    b.bookingNumber === currentBookingNumber || b.code === currentBookingNumber
  );
  // 🔥 FIX: Merge with Page 1 data (source of truth for vessel/skipper/dates)
  const baseBookingInfo = renderBookingFromContext || contextData?.data || {};
  const bookingInfo = {
    ...baseBookingInfo,
    vesselName: page1Data?.vesselName || baseBookingInfo?.vesselName,
    skipperFirstName: page1Data?.skipperFirstName || baseBookingInfo?.skipperFirstName,
    skipperLastName: page1Data?.skipperLastName || baseBookingInfo?.skipperLastName,
    checkInDate: page1Data?.checkInDate || baseBookingInfo?.checkInDate,
    checkOutDate: page1Data?.checkOutDate || baseBookingInfo?.checkOutDate,
  };

  if (!keysLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: brand.pageBg }}>
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2" style={{ borderColor: brand.blue }} />
          <div className="mt-4 text-gray-600">Loading items...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4" style={{ background: brand.pageBg }}>
      <input ref={fileInputRef} type="file" multiple className="hidden" onChange={handleFiles} />
      
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        {SHOW_BOOKING_INFO_ON_CHECKLIST_PAGES && (
        <div className="mb-6 p-4 rounded-xl border-2" style={{ backgroundColor: brand.successBg, borderColor: brand.successBorder }}>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <div className="text-xs text-gray-600">Booking Number</div>
              <div className="text-lg font-bold">{currentBookingNumber || 'N/A'}</div>
              <div className="text-xs text-gray-600 mt-2">Check-in Date</div>
              <div className="text-base font-semibold">{formatDate(bookingInfo?.checkInDate)}</div>
            </div>
            <div className="text-center">
              <div className="text-xs text-gray-600">Yacht</div>
              <div className="text-lg font-bold">{bookingInfo?.vesselName || 'N/A'}</div>
            </div>
            <div className="text-right">
              <div className="text-xs text-gray-600">Skipper</div>
              <div className="text-lg font-bold">{bookingInfo?.skipperFirstName || ''} {bookingInfo?.skipperLastName || ''}</div>
              <div className="text-xs text-gray-600 mt-2">Check-out Date</div>
              <div className="text-base font-semibold">{formatDate(bookingInfo?.checkOutDate)}</div>
            </div>
          </div>
        </div>
        )}

        <div className="text-center mb-4">
          <button className="px-6 py-3 rounded-lg font-bold text-white text-lg" style={{ backgroundColor: brand.blue }}>
            TAILWIND YACHTING
          </button>
        </div>

        <div className="mb-4">
          <h1 className="text-2xl font-bold text-center" style={{ color: brand.navy }}>{t.title}</h1>
        </div>

        <div className="mb-4 text-center">
          <button
            onClick={handleSelectAllOk}
            className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow-md"
          >
            ✓ {t.selectAllOk || 'SELECT ALL OK'}
          </button>
        </div>


        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className={`px-2 py-1 rounded text-xs font-semibold ${isOnline ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
              {isOnline ? '🟢 Online' : '🔴 Offline'}
            </span>
            <button onClick={() => setShowLangPopup(!showLangPopup)}
                  style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ccc', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <img src={flagImgP2(LANG_MAP_P2.find(l => l.code === lang)?.country || "GB")} alt="" style={{width: "24px", height: "18px"}} /> {lang.toUpperCase()}
              </button>
              {showLangPopup && (
                <div style={{
                  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                  background: 'rgba(0,0,0,0.5)', zIndex: 9999,
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }} onClick={() => setShowLangPopup(false)}>
                  <div style={{
                    background: 'white', borderRadius: '16px', padding: '24px',
                    maxWidth: '340px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                  }} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
                    <h3 style={{ textAlign: 'center', marginBottom: '16px', fontSize: '18px', color: '#1e293b' }}>
                      Select Language
                    </h3>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                      {LANG_MAP_P2.map(({ code, country, label }) => (
                        <button key={code} onClick={() => handleLangChange(code)}
                          style={{
                            padding: '12px 8px', borderRadius: '10px', border: 'none',
                            background: lang === code ? 'linear-gradient(135deg, #0c4a6e, #0ea5e9)' : '#f1f5f9',
                            color: lang === code ? 'white' : '#334155',
                            fontSize: '15px', fontWeight: lang === code ? 700 : 500,
                            cursor: 'pointer', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', gap: '8px'
                          }}>
                          <img src={flagImgP2(country)} alt="" style={{width: "24px", height: "18px", borderRadius: "2px"}} /> {label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            {/* 🔒 Inline Logout removed — auth UI lives only on Page 5 (signature). */}
            {/* handleEmployeeLogout state/handlers retained as dead code per spec. */}
            {null}
          </div>
          <div className="text-sm font-semibold" style={{ color: brand.black }}>
            Progress: {percentage}%
          </div>
        </div>

        <div className="mb-4">
          <div className="text-base font-semibold" style={{ color: brand.black }}>
            {t.mode}: <span style={{ color: mode === "in" ? brand.blue : brand.pink, fontSize: '17px' }}>
              {mode === "in" ? t.checkIn : t.checkOut}
            </span>
          </div>
        </div>

        <div ref={mainsailRef}>
          <DynamicBox
            boxKey="mainsail_genoa"
            lang={lang}
            initialValue={mainsailAgreed}
            onAcceptChange={setMainsailAgreed}
            currentBookingNumber={currentBookingNumber}
            mode={mode}
          />
        </div>

        <TableSection
          data={hullItems}
          t={t}
          setPrice={setPrice}
          incQty={incQty}
          decQty={decQty}
          toggleInOk={toggleInOk}
          setOut={setOut}
          openCamera={openCamera}
          handleFiles={handleFiles}
          openFilePicker={openFilePicker}
          removeRow={removeRow}
          mode={mode}
          getLabel={getLabel}
          isEmployee={isEmployee}
          currentEmployee={currentEmployee}
          newItem=""
          setNewItem={() => {}}
          addItem={() => {}}
          readOnly={isFrozen}
          markProblematic={true}
          sectionTitle={t.hullTitle || "HULL"}
        />

        <div ref={diversReportRef}>
          <DynamicBox
            boxKey="divers_report"
            lang={lang}
            initialValue={diversImageUploaded}
            onAcceptChange={setDiversImageUploaded}
            onImageChange={(uploaded, fileData) => setDiversReportFile(fileData)}
            initialFile={diversReportFile}
            legacyCallback={true}
            enableZoom={true}
            currentBookingNumber={currentBookingNumber}
            mode={mode}
          />
        </div>

        <div ref={diversAgreementRef}>
          <DynamicBox
            boxKey="divers_agreement"
            lang={lang}
            initialValue={diversAgreed}
            onAcceptChange={setDiversAgreed}
            currentBookingNumber={currentBookingNumber}
            mode={mode}
          />
        </div>
        {/* === MOVED BOXES (DB page_group=page3). Consent is DB-backed in DynamicBox via box-consents.php, per booking+mode. === */}
        <DynamicBox
          boxKey="toilet_warning"
          lang={lang}
          onAcceptChange={() => {}}
          currentBookingNumber={currentBookingNumber}
          mode={mode}
          showWarningIcon={true}
        />
        <DynamicBox
          boxKey="return_acknowledgement"
          lang={lang}
          onAcceptChange={() => {}}
          currentBookingNumber={currentBookingNumber}
          mode={mode}
        />
        <DynamicBox
          boxKey="terms_conditions"
          lang={lang}
          onAcceptChange={() => {}}
          currentBookingNumber={currentBookingNumber}
          mode={mode}
        />
        <DynamicBox
          boxKey="privacy_consent"
          lang={lang}
          onAcceptChange={() => {}}
          currentBookingNumber={currentBookingNumber}
          mode={mode}
        />
        <DynamicBox
          boxKey="warning_notice"
          lang={lang}
          onAcceptChange={() => {}}
          currentBookingNumber={currentBookingNumber}
          mode={mode}
          showWarningIcon={true}
        />

        <TableSection
          data={dinghyItems}
          t={t}
          setPrice={setPrice}
          incQty={incQty}
          decQty={decQty}
          toggleInOk={toggleInOk}
          setOut={setOut}
          openCamera={openCamera}
          handleFiles={handleFiles}
          openFilePicker={openFilePicker}
          removeRow={removeRow}
          mode={mode}
          getLabel={getLabel}
          isEmployee={isEmployee}
          currentEmployee={currentEmployee}
          newItem=""
          setNewItem={() => {}}
          addItem={() => {}}
          readOnly={isFrozen}
          markProblematic={true}
          sectionTitle={t.dinghyTitle || "DINGHY AND OUTBOARD ENGINE"}
        />

        {(() => { const _visibleOptional = optionalItems; return _visibleOptional.length > 0 ? (
          <TableSection
            data={_visibleOptional}
            t={t}
            setPrice={setPrice}
            incQty={incQty}
            decQty={decQty}
            toggleInOk={toggleInOk}
            setOut={setOut}
            openCamera={openCamera}
            handleFiles={handleFiles}
            openFilePicker={openFilePicker}
            removeRow={removeRow}
            mode={mode}
            getLabel={getLabel}
            isEmployee={isEmployee}
            currentEmployee={currentEmployee}
            newItem=""
            setNewItem={() => {}}
            addItem={() => {}}
            readOnly={isFrozen}
            markProblematic={true}
            sectionTitle={t.optionalTitle || "OPTIONAL EQUIPMENT"}
          />
        ) : null; })()}

        <div className="mt-6 border-2 rounded-xl p-4" style={{ borderColor: brand.blue }}>
          <label className="block font-semibold" style={{ color: brand.black }}>{t.note}</label>
          <textarea 
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            className="mt-2 w-full border rounded p-3 min-h-[180px] bg-white" 
            placeholder={t.notePH}
            style={{ borderColor: brand.black, color: brand.black }} 
          />
        </div>

        <div className="mt-6 border-2 rounded-xl p-4" style={{ borderColor: brand.blue }}>
          <label className="block font-semibold" style={{ color: brand.black }}>{t.picsTitle}</label>
          {mediaCards.length ? (
            <div className="mt-3 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
              {mediaCards.map(({ m, i, key, id }) => (
                <div key={`${id}-${i}`} className="relative border rounded p-1 text-xs" style={{ borderColor: brand.black }}>
                  {m.type === "img" ? (
                    <>
                      <img src={m.url} alt={`pic-${i}`} className="w-full h-24 object-cover rounded" />
                      <button type="button" onClick={() => setZoomUrl(m.url)}
                        className="absolute right-1 top-1 px-2 py-0.5 text-[10px] border rounded bg-white"
                        style={{ borderColor: brand.black }}>🔍</button>
                    </>
                  ) : <span>{m.name || "file"}</span>}
                  <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); removeMedia(id, m); }}
                    className="absolute -top-2 -right-2 w-6 h-6 rounded-full border text-[10px] z-10"
                    style={{ background: "#fff", borderColor: brand.black, color: brand.black }} title={t.remove}>×</button>
                  <div className="mt-1 truncate" title={ITEM_LABELS[key]?.[lang] || ITEM_LABELS[key]?.['en'] || key}>
                    {ITEM_LABELS[key]?.[lang] || ITEM_LABELS[key]?.['en'] || key}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-2 text-sm" style={{ color: brand.black }}>
              {lang === "el" ? "Δεν έχουν προστεθεί αρχεία ακόμη." : "No files added yet."}
            </div>
          )}
        </div>

        {zoomUrl && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" onClick={() => setZoomUrl(null)}>
            <div className="bg-white rounded-xl p-4 w-[95vw] max-w-5xl" onClick={(e) => e.stopPropagation()}>
              <div className="mb-3 text-base font-semibold">{t.picsTitle}</div>
              <div className="w-full flex items-center justify-center" style={{ height: "80vh" }}>
                <img src={zoomUrl} alt="zoom" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
              </div>
              <div className="flex justify-end mt-3">
                <button type="button" onClick={() => setZoomUrl(null)} className="px-3 py-1 rounded border text-sm"
                  style={{ borderColor: brand.black }}>{t.ok || "OK"}</button>
              </div>
            </div>
          </div>
        )}

        <div ref={signatureRef} className="mt-8">
          {SHOW_PER_PAGE_SIGNATURES && (<SignatureBox key={mode + '-' + currentBookingNumber} brand={brand} lang={lang} onSignChange={setSignatureDone} onImageChange={setSignatureImage} initialImage={null} currentBookingNumber={currentBookingNumber} mode={mode} />)}
        </div>

        <div className="mt-6 grid grid-cols-2 md:flex md:flex-wrap md:justify-between gap-2 md:gap-3">
          <button type="button" onClick={handlePrevious}
            className="px-5 py-3 rounded transition-colors font-semibold min-h-[44px] col-span-2 md:col-span-1"
            style={{ background: "#6B7280", color: "#fff" }}>
            ← {t.prev}
          </button>
          
          <div className="grid grid-cols-2 md:flex md:flex-wrap gap-2 md:gap-3 col-span-2 md:col-span-1">
            <button type="button" onClick={handleSaveDraft}
              className="px-5 py-3 rounded transition-colors font-semibold min-h-[44px]"
              style={{ background: "#4B5563", color: "#fff" }}>
              {t.save}
            </button>
            <button type="button" onClick={handleGeneratePDF}
              className="px-5 py-3 rounded font-semibold transition-colors shadow-md min-h-[44px]"
              style={{ background: "#DC2626", color: "#fff" }}>
              📄 {t.pdf}
            </button>
            <button type="button" onClick={handleNext}
              className="px-5 py-3 rounded font-semibold transition-colors shadow-md min-h-[44px]"
              style={{ background: brand.blue, color: "#fff" }}>
              {t.next} →
            </button>
          </div>
        </div>
      </div>

      {camForId && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-4 w-[90vw] max-w-md" style={{ color: brand.black }}>
            <div className="font-semibold mb-2">{t.camera}</div>
            <video ref={videoRef} autoPlay playsInline className="w-full rounded" />
            <div className="flex gap-2 mt-3 justify-end">
              <button className="px-3 py-2 rounded border" style={{ borderColor: brand.black }} onClick={capturePhoto}>
                📸 Capture
              </button>
              <button className="px-3 py-2 rounded border" style={{ borderColor: brand.black }} onClick={closeCamera}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showBaseManagerModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl" style={{ color: brand.black }}>
            <div className="flex items-start gap-3 mb-4">
              <div style={{ fontSize: '32px', lineHeight: 1 }}>⚙️</div>
              <div className="text-base font-semibold leading-snug">
                {t.contactBaseManagerTech}
              </div>
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setShowBaseManagerModal(false)}
                className="px-5 py-2 rounded-lg font-semibold text-white"
                style={{ backgroundColor: brand.blue }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating Chat Widget */}
    </div>
  );
}